import type {FC} from 'react';
import React from 'react';
import {useMissingInfoController} from '@app/hooks/controllers/useMissingInfoController';
import MissingInfoForm from '@app/components/MissingInfoForm';
import {useTranslation} from '@app/hooks/useTranslation';
import {getStaticTranslations} from '@app/modules/translations';
import type {DzrGetStaticProps} from '@app/types/next';
import {AuthLayout} from '@app/components/Layouts/pages/AuthLayout';
import {VStack} from '@tempo/core';
import {AccountSection} from '@app/components/Layouts/elements';

const MissingInfoPage: FC = () => {
	const t = useTranslation();
	const {isLoading, missingInfos} = useMissingInfoController();

	return (
		<AuthLayout
			isLoading={isLoading}
			title={t('common.title_welcomeEXCL')}
			detail={t('shaker.finalizeaccounttoenjoyfullXP')}
		>
			<AccountSection>
				{missingInfos && (
					<VStack spacing="spacing.l" w="100%" mx="auto" maxW="512px">
						<MissingInfoForm missingInfos={missingInfos} />
					</VStack>
				)}
			</AccountSection>
		</AuthLayout>
	);
};

export const getStaticProps: DzrGetStaticProps = async ({locale = ''}) => {
	const translations = await getStaticTranslations(locale, {
		additionnalNamespaces: ['error', 'shaker', 'password'],
	});
	return {
		props: {
			colorMode: 'dark',
			useGraphQl: true,
			...translations,
		},
	};
};

export default MissingInfoPage;
